<template>
  <el-dialog
    width="720px"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    destroy-on-close
    @close="closeDialog"
  >
    <div slot="title">
      {{ dialogType === 'add' ? $t('shop-site::paySetting::add_button') : $t('shop-site::paySetting::edit_button') }}
      <span v-show="dialogType === 'add'">
        <i class="icon-a-01wenhao iconfont-el"></i>
        <el-button type="text" @click="toGuider" style="font-size: 14px; padding: 0">
          {{ $t('shop-site::paySetting::tip') }}
        </el-button>
      </span>
    </div>

    <el-form label-position="top" label-suffix=":" label-width="130px" ref="account" :model="account" :rules="rules">
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item :label="$t('shop-site::paySetting::table_shop')" prop="shopId">
            <el-select
              v-model="account.shopId"
              :placeholder="$t('shop-site::paySetting::placeholder_shop')"
              @change="changeShop"
              style="width: 100%"
            >
              <el-option
                :label="item.label"
                :value="item.value"
                v-for="(item, index) in shoplists"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('shop-site::paySetting::table_accountName')" prop="accountName">
            <el-input
              v-model="account.accountName"
              :placeholder="$t('shop-site::paySetting::placeholder_accountName')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('shop-site::paySetting::table_account')" prop="loginAccount">
            <el-input
              v-model="account.loginAccount"
              :placeholder="$t('shop-site::paySetting::placeholder_account')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('shop-site::paySetting::table_accountId')" prop="payMerchantId">
            <el-input
              v-model="account.payMerchantId"
              :placeholder="$t('shop-site::paySetting::placeholder_accountId')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('shop-site::paySetting::table_apiName')" prop="apiUserName">
            <el-input
              v-model="account.apiUserName"
              :placeholder="$t('shop-site::paySetting::placeholder_apiName')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('shop-site::paySetting::table_apiSecret')" prop="apiPassword">
            <el-input
              v-model="account.apiPassword"
              :placeholder="$t('shop-site::paySetting::placeholder_apiSecret')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('shop-site::paySetting::table_apiSign')" prop="apiSignature">
            <el-input type="textarea" :rows="3" v-model="account.apiSignature"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="PaypalAccount" prop="appKey">
            <el-input type="textarea" :rows="3" v-model="account.appKey"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="PaypalSecret" prop="appSecret">
            <el-input type="textarea" :rows="3" v-model="account.appSecret"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog(false)" size="medium">{{ $t('system::common::btn::cancel') }}</el-button>
      <el-button type="primary" size="medium" @click="submitForm" :loading="loading">
        {{ $t('system::common::btn::confirm') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updatePaypalAccount, addPaypalAccount, getShopList } from '@/server/order'
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    handleAccount: {
      type: Object,
      default: () => {},
    },
    dialogType: {
      type: String,
      default: '',
    },
    shopList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialogVisible: false,
      account: {},
      loading: false,
      shoplists: [],
      rules: {
        shopId: [{ required: true, message: this.$t('shop-site::paySetting::placeholder_shop'), trigger: 'change' }],
        accountName: [
          { required: true, message: this.$t('shop-site::paySetting::placeholder_accountName'), trigger: 'blur' },
        ],
        loginAccount: [
          { required: true, message: this.$t('shop-site::paySetting::placeholder_account'), trigger: 'blur' },
        ],
        payMerchantId: [
          { required: true, message: this.$t('shop-site::paySetting::placeholder_accountId'), trigger: 'blur' },
        ],
        apiUserName: [
          { required: true, message: this.$t('shop-site::paySetting::placeholder_apiName'), trigger: 'blur' },
        ],
        apiPassword: [
          { required: true, message: this.$t('shop-site::paySetting::placeholder_apiSecret'), trigger: 'blur' },
        ],
        apiSignature: [
          { required: true, message: this.$t('shop-site::paySetting::placeholder_apiSign'), trigger: 'blur' },
        ],
        appKey: [
          { required: true, message: this.$t('shop-site::paySetting::placeholder_paypalAccount'), trigger: 'blur' },
        ],
        appSecret: [
          { required: true, message: this.$t('shop-site::paySetting::placeholder_paypalSecret'), trigger: 'blur' },
        ],
      },
    }
  },
  mounted() {
    this.shoplists = this.shopList
    if (this.shoplists.length === 0) {
      this.getShopList()
    }
  },
  watch: {
    handleAccount: {
      handler: function (val) {
        this.account = { ...val }
      },
      immediate: true, // 第一次刷新页面时就会执行
    },
    dialogVisible(val) {
      this.$emit('input', val)
    },
    value(val) {
      this.dialogVisible = val
      if (!val) {
        this.closeDialog()
      }
      this.$nextTick(() => this.$refs.account.clearValidate())
    },
  },
  methods: {
    toGuider() {
      window.open('https://docs.qq.com/doc/DTG1sQUdBVFlTTkZo', '_blank')
    },
    async getShopList() {
      const { data } = await getShopList()
      if (data.code === this.$code) {
        this.shoplists =
          data.data &&
          data.data.map(item => ({
            label: item.shopName,
            value: item.shopId,
          }))
      }
    },
    submitForm() {
      this.$refs.account.validate(valid => {
        if (valid) {
          this.loading = true
          if (this.dialogType === 'add') {
            this.addPaypalAccount()
          } else if (this.dialogType === 'update') {
            this.updatePaypalAccount()
          }
        }
      })
    },
    async addPaypalAccount() {
      let { data } = await addPaypalAccount(this.account)
      if (data.code === this.$code) {
        await this.$store.dispatch('getBindData')
        this.$message.success(this.$t('system::tip::add_success'))
        this.closeDialog(true)
      }
      this.loading = false
    },
    async updatePaypalAccount() {
      let { data } = await updatePaypalAccount(this.account)
      if (data.code === this.$code) {
        this.$message.success(this.$t('system::tip::change_success'))
        this.closeDialog(true)
      }
      this.loading = false
    },
    changeShop(e) {
      for (let i = 0; i < this.shoplists.length; i++) {
        if (this.shoplists[i].value === e) {
          this.account.shopName = this.shoplists[i].label
          break
        }
      }
    },
    closeDialog(refresh) {
      this.dialogVisible = false
      this.$emit('closeDialog', refresh)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-dialog__body {
    // max-height: 420px;
    // overflow-y: auto;
    padding: 24px 32px;
  }
}
.icon-a-01wenhao {
  margin-left: 5px;
  color: #999;
  font-size: 14px;
}
</style>
